export default __webpack_public_path__ + "static/media/high-quality-image.a01971a1.svg";